import { render, staticRenderFns } from "./editCompanyModalContent.vue?vue&type=template&id=58588ab0&scoped=true"
import script from "./editCompanyModalContent.vue?vue&type=script&lang=js"
export * from "./editCompanyModalContent.vue?vue&type=script&lang=js"
import style0 from "./editCompanyModalContent.vue?vue&type=style&index=0&id=58588ab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58588ab0",
  null
  
)

export default component.exports